import { Injectable } from '@angular/core';
import { BankTransactionModel } from '@app/core/Models/bank/bank-overview/bank-overview';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  DeleteBankStatementTransaction,
  GetBankTrasnactions,
  GetCashInHandTrasnactions,
} from './bank-overview.action';
import { BankOverviewService } from '@app/core/Services';
import { tap } from 'rxjs/operators';

export class BankOverviewStateInfo {
  getBankTransactions?: Array<BankTransactionModel>;
  totalRecord?: number;
  actions?: any;
  isBankStatementTransactionDeleted: boolean;
  getCashInHandTransactions?: Array<BankTransactionModel>;
  cashInHandactions?: any;
  cashInHandDetails?: any;
}

@State<BankOverviewStateInfo>({
  name: 'bankOverview',
  defaults: {
    isBankStatementTransactionDeleted: false,
  },
})
@Injectable()
export class BankOverviewState {
  constructor(private bankOverviewService: BankOverviewService) {}

  @Selector()
  static totalRecord(state: BankOverviewStateInfo): number {
    return state.totalRecord ?? 0;
  }

  @Action(GetBankTrasnactions, { cancelUncompleted: true })
  GetBankTrasnactions(
    { patchState }: StateContext<BankOverviewStateInfo>,
    action: GetBankTrasnactions
  ) {
    return this.bankOverviewService.getBankTransctions(action.queryParams).pipe(
      tap({
        next: (result) => {
          patchState({
            getBankTransactions: result.resultSet.data,
            totalRecord: result.paginationModel.totalItemCount,
            actions: result.actions,
          });
        },
      })
    );
  }

  @Action(DeleteBankStatementTransaction)
  deleteBankImportTransactionHistory(
    { getState, patchState }: StateContext<BankOverviewStateInfo>,
    action: DeleteBankStatementTransaction
  ) {
    return this.bankOverviewService
      .deleteBankStatementTransaction(action.ids)
      .pipe(
        tap((res) => {
          patchState({
            isBankStatementTransactionDeleted: res,
          });
        })
      );
  }

  @Action(GetCashInHandTrasnactions, { cancelUncompleted: true })
  GetCashInHandTrasnactions(
    { patchState }: StateContext<BankOverviewStateInfo>,
    action: GetCashInHandTrasnactions
  ) {
    return this.bankOverviewService.getCashInHandTransctions(action.queryParams).pipe(
      tap({
        next: (result) => {
          patchState({
            getCashInHandTransactions: result.resultSet.data,
            totalRecord: result.paginationModel.totalItemCount,
            cashInHandactions: result.actions,
            cashInHandDetails: result.cashInHandDetails
          });
        },
      })
    );
  }
}
